import { FormBuilder } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { DOC_TEMPLATES } from '../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var DocumentNumberSettingComponent = (function () {
    function DocumentNumberSettingComponent(apiService, formBuilder, modalService, translateService) {
        this.apiService = apiService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.translateService = translateService;
        this.yearPatternChoices = [
            { label: 'เลขปี 2 ตำแหน่งในรูป ค.ศ.', value: '%y', display: 'YY' },
            { label: 'เลขปี 4 ตำแหน่งในรูป ค.ศ.', value: '%Y', display: 'YYYY' },
            { label: 'ไม่แสดง', value: '', display: '' },
        ];
        this.monthPatternChoices = [
            { label: 'แสดง', value: '%m', display: 'MM' },
            { label: 'ไม่แสดง', value: '', display: '' },
        ];
        this.dayPatternChoices = [
            { label: 'แสดง', value: '%d', display: 'DD' },
            { label: 'ไม่แสดง', value: '', display: '' },
        ];
        this.documentTypeChoices = [];
        this.showCancel = false;
        this.saving = false;
    }
    DocumentNumberSettingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function () {
            _this.loadDocumentTypeChoices();
        });
        this.loadDocumentTypeChoices();
        this.documentNumberForms = this.formBuilder.group({
            items: this.formBuilder.array([
                this.initForm('receipt_tax_invoice'),
                this.initForm('credit_note'),
                this.initForm('debit_note'),
            ]),
        });
        this.documentNumberForms.valueChanges.subscribe(function () {
            _this.showCancel = true;
        });
        this.loadDocumentNumberSetting();
    };
    DocumentNumberSettingComponent.prototype.initForm = function (documentType) {
        return this.formBuilder.group({
            documentType: [documentType],
            prefix: [''],
            yearPattern: ['%y'],
            monthPattern: ['%m'],
            dayPattern: ['%d'],
            runningDigit: [4]
        });
    };
    DocumentNumberSettingComponent.prototype.save = function () {
        var _this = this;
        this.saving = true;
        var payload = this.documentNumberForms.value.items.map(function (item) { return ({
            document_type: item.documentType,
            prefix: item.prefix,
            year_pattern: item.yearPattern,
            month_pattern: item.monthPattern,
            day_pattern: item.dayPattern,
            running_digit: item.runningDigit,
        }); });
        this.apiService.saveDocumentNumberSetting(payload).subscribe(function () {
            _this.saving = false;
            _this.resultMessage = _this.translateService.instant('SETTINGS.SAVED-SUCCESSFULLY');
            _this.modal = _this.modalService.open(_this.saveResultModal, { centered: true, backdrop: 'static' });
        }, function (error) {
            _this.saving = false;
            _this.resultMessage = _this.translateService.instant('ERROR.TRY-AGAIN');
            _this.modal = _this.modalService.open(_this.saveResultModal, { centered: true, backdrop: 'static' });
        });
    };
    DocumentNumberSettingComponent.prototype.closeModal = function () {
        this.modal.close();
        this.resultMessage = undefined;
    };
    DocumentNumberSettingComponent.prototype.loadDocumentTypeChoices = function () {
        var th = this.translateService.currentLang === 'th';
        this.documentTypeChoices = DOC_TEMPLATES.map(function (item) { return (th ? { label: item.name, value: item.type } : { label: item.nameEN, value: item.type }); });
    };
    DocumentNumberSettingComponent.prototype.loadDocumentNumberSetting = function () {
        var _this = this;
        this.apiService.getDocumentNumberSettings().subscribe(function (response) {
            _this.showCancel = false;
            if (!response.length) {
                return;
            }
            var _loop_1 = function (formGroup) {
                var foundObject = response.find(function (item) { return item.document_type === formGroup.value.documentType; });
                if (foundObject) {
                    formGroup.patchValue({
                        prefix: foundObject.prefix,
                        yearPattern: foundObject.year_pattern,
                        monthPattern: foundObject.month_pattern,
                        dayPattern: foundObject.day_pattern,
                        runningDigit: foundObject.running_digit,
                    });
                }
            };
            for (var _i = 0, _a = _this.documentNumberForms.controls.items.controls; _i < _a.length; _i++) {
                var formGroup = _a[_i];
                _loop_1(formGroup);
            }
        });
    };
    Object.defineProperty(DocumentNumberSettingComponent.prototype, "items", {
        get: function () {
            return this.documentNumberForms.get('items');
        },
        enumerable: true,
        configurable: true
    });
    DocumentNumberSettingComponent.prototype.getDocumentTypeDisplay = function (index) {
        var documentType = this.documentNumberForms.value.items[index].documentType;
        return this.documentTypeChoices.find(function (item) { return item.value === documentType; }).label;
    };
    DocumentNumberSettingComponent.prototype.getPatternDisplay = function (index) {
        var documentNumberSetting = this.documentNumberForms.value.items[index];
        var yearPattern = this.getDisplayFromChoices(this.yearPatternChoices, documentNumberSetting.yearPattern);
        var monthPattern = this.getDisplayFromChoices(this.monthPatternChoices, documentNumberSetting.monthPattern);
        var dayPattern = this.getDisplayFromChoices(this.dayPatternChoices, documentNumberSetting.dayPattern);
        var runningDigit = '0'.repeat(documentNumberSetting.runningDigit - 1);
        var prefix = documentNumberSetting.prefix ? documentNumberSetting.prefix + '-' : '';
        return "" + prefix + yearPattern + monthPattern + dayPattern + "-" + runningDigit + "1";
    };
    DocumentNumberSettingComponent.prototype.getDisplayFromChoices = function (choices, value) {
        return choices.find(function (item) { return item.value === value; }).display;
    };
    return DocumentNumberSettingComponent;
}());
export { DocumentNumberSettingComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting.component.ts.pre-build-optimizer.js